import LockIcon from '@mui/icons-material/Lock';

import useColorByStatus from './useColorByStatus';
import STATUSES from '../constants/statuses';
import TYPES from '../constants/activityType';

function getProjectStatusLabel(status, isCurrent, isLocked, translations) {
  const defaultString = translations.toComplete;

  if (isLocked) {
    return defaultString;
  }

  const labelByStatus = {
    [STATUSES.STATUS_IN_PROGRESS]: isCurrent ? translations.inProgress : defaultString,
    [STATUSES.STATUS_NOT_STARTED]: translations.toComplete,
    [STATUSES.STATUS_CAN_RETRY]: translations.toRework,
    [STATUSES.STATUS_READY_FOR_REVIEW]: translations.presentationToBeScheduled,
    [STATUSES.STATUS_AWAITING_REVIEW]: translations.presentationScheduled,
    [STATUSES.STATUS_PASSED]: translations.completed,
  };

  return labelByStatus[status] || defaultString;
}

function getDisplayStatus(learningActivityStatus, isCurrent) {
  let displayStatus = learningActivityStatus;

  if (learningActivityStatus === STATUSES.STATUS_IN_PROGRESS && !isCurrent) {
    displayStatus = STATUSES.STATUS_NOT_STARTED;
  }

  if (learningActivityStatus === STATUSES.STATUS_READY_FOR_REVIEW) {
    displayStatus = STATUSES.STATUS_AWAITING_REVIEW;
  }

  return displayStatus;
}

const useProjectStatus = ({
  learningActivityStatus,
  progression,
  number,
  isCurrent = false,
  isLocked = false,
  translations = {
    inProgress: 'Project in progress',
    toComplete: 'Project to complete',
    toRework: 'Project to rework',
    presentationToBeScheduled: 'Project presentation to schedule',
    presentationScheduled: 'Project presentation scheduled',
    completed: 'Project completed',
  },
}) => {
  const hasProgression = typeof progression === 'number';
  const displayStatus = getDisplayStatus(learningActivityStatus, isCurrent);
  const hideProgression =
    !hasProgression || isLocked || learningActivityStatus === STATUSES.STATUS_PASSED;

  // fake status if the item is locked
  const color = useColorByStatus(isLocked ? STATUSES.STATUS_NOT_STARTED : displayStatus);

  const statusComponentProps = {
    number,
    status: displayStatus,
    isIconHidden:
      number &&
      (learningActivityStatus === STATUSES.STATUS_NOT_STARTED ||
        (!isCurrent && learningActivityStatus === STATUSES.STATUS_IN_PROGRESS)),
    activityType: TYPES.PROJECT,
  };

  if (isLocked) {
    statusComponentProps.forcedIcon = LockIcon;
    statusComponentProps.isIconHidden = false;
  }

  return {
    color,
    statusLabel: getProjectStatusLabel(learningActivityStatus, isCurrent, isLocked, translations),
    statusComponentProps,
    shouldShowProgression: hasProgression && !hideProgression,
  };
};

export default useProjectStatus;
